export class MoovStepPremierServiceConfigurationDTO{
    public id!: number;
    public moovStepConfigurationId!: number;
    public premierServiceId!: number;
    public premierServiceProductId!: number;
    public customerPremierPartnerServiceConfigurationId!: number;
    public premierPartnerId!: number;
    public premierServiceType!: string;
    public premierServiceProductType!: string;
    public status!: number;
    public parameters!: string;
    public recurrenceType!: number;
    public recurrenceInterval!: number;
    public recurrenceDays!: string;
    public recurrenceHour!: number;
    public recurrenceMinute!: number;
    public useLastDayOfMonth!: boolean;
    public recurrenceStartDate!: string;
    public timeZoneInfoId!: string;
    public addedByUserId!: number;
    public editedByUserId!: number;
    public added!: string;
    public edited!: string;
}